import { render } from "./moneyList.vue?vue&type=template&id=35d753de&scoped=true"
import script from "./moneyList.vue?vue&type=script&lang=js"
export * from "./moneyList.vue?vue&type=script&lang=js"

import "./moneyList.vue?vue&type=style&index=0&id=35d753de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d753de"]])

export default __exports__